import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { addComparisonPlan, removeComparisonPlan } from '../../../actions/searchActions';
import { formatURL, isMobile, isB2b, cleanDate } from '../../../utils';
import ComparisonItem from './ComparisonItem';

class ComparisonBar extends Component {
  constructor(props) {
    super(props);
    this.comparePlans = this.comparePlans.bind(this);
  }

  comparePlans() {
    const selectedPlans = this.props.plans.map((plan) => plan.code);

    let basePath = '/seguro-viagem/comparacao';

    if (isB2b()) basePath = '/seguro-viagem/comparacao-b2b';

    const location = {
      pathname: formatURL(
        this.props.match.params,
        basePath +
          '/' +
          this.props.match.params.destination +
          '/' +
          cleanDate(this.props.match.params.begin_date) +
          '/' +
          cleanDate(this.props.match.params.end_date) +
          '/?products_ids=' +
          selectedPlans.join('+')
      ),
    };

    this.props.history.push(location);
  }



  render() {
    let plans = [{}, {}, {}, {}];
    if (isMobile()) plans = [{}, {}];

    plans = plans.map((plan, i) => this.props.plans[i] || plan);

    return (
      <section className="planos">
        <div className="component">
          <div className="planos-comparar flex">
            <p className="escolha">Escolha de 2 a 4 planos para fazer uma comparação</p>
            <ul className="planos-selecionados flex">
              {plans.map((plan, i) => (
                <ComparisonItem
                  key={i}
                  removeComparisonPlan={this.props.removeComparisonPlan}
                  plan={plan}
                  position={i}
                  providers={this.props.providers}
                />
              ))}
            </ul>

            <button
              className="btn-compare"
              onClick={this.comparePlans}
              disabled={this.props.plans.length <= 1}
              data-cy="botao-comparar"
            >
              Comparar
            </button>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  plans: state.search.comparisonPlans,
  providers: state.global.providers,
});

export default withRouter(
  connect(mapStateToProps, {
    addComparisonPlan,
    removeComparisonPlan,
  })(ComparisonBar)
);



// WEBPACK FOOTER //
// ./src/components/search/comparison_bar/ComparisonBar.jsx